export default "__VITE_ASSET__dccfae91__"